import { useEffect, useState } from 'react'
import { usePipelineStore } from 'app/stores/StoreContext'
import type { PipelineType } from 'app/types/entities'

/** The pipeline behind a list row, read by id; nothing is read when `skip` is set (the row's List is already in hand). */
export function useListPipeline(pipelineId: string, skip: boolean): { pipeline?: PipelineType; error?: string } {
  const pipelineStore = usePipelineStore()
  const [pipeline, setPipeline] = useState<PipelineType | undefined>()
  const [error, setError] = useState<string | undefined>()

  useEffect(() => {
    if (skip) return
    pipelineStore.fetchOne(pipelineId).then((result) => {
      if (result.error) setError(result.error.message)
      else if (result.data) setPipeline((result.data as { pipeline?: PipelineType }).pipeline)
    })
  }, [pipelineId])

  return { pipeline, error }
}
